import { Component, OnInit } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialog } from '@generic/confirm-dialog/confirm-dialog.component';
import { NotificationsService } from '@services/notifications.service';
import { HttpUtilService } from '@services/http-util.service';
import { environment } from '@env/environment';
import { ScaffoldDialogService } from '@app/framework/dialog/scaffold-dialog.service';

@Component({
    selector: 'app-model-keys',
    templateUrl: './model-keys.component.html',
    styleUrls: ['./model-keys.component.scss'],
    standalone: false
})
export class ModelKeysComponent implements OnInit {
  modelId;
  currentKeys = [];
  keyUpdated = [];
  newKey = {
    name: '',
    encrypted: false,
    json_data: { canvas: '', blackboard: '' },
  };
  lmsList = [];

  constructor(
    private dataModelService: DataModelService,
    private route: ActivatedRoute,
    private dialog: ScaffoldDialogService,
    private router: Router,
    private httpUtils: HttpUtilService,
    private notifications: NotificationsService
  ) {}

  ngOnInit() {
    // this.lmsList = ['canvas', 'blackboard', 'sakai'];  // This needs to be a service since it will be different per school

    this.route.paramMap.subscribe(params => {
      this.modelId = params.get('id');

      this.getKeys();
    });
  }

  addKey() {
    if (!this.alreadyExists() && this.newKey.name != '') {
      this.dataModelService
        .addKey(
          this.modelId,
          this.newKey.name,
          this.newKey.json_data,
          this.newKey.encrypted
        )
        .subscribe(data => {
          if (data.errorMessage) {
            this.notifications.popNotification(data.errorMessage, 'X');
          } else {
            this.getKeys();
            this.newKey = {
              name: '',
              encrypted: false,
              json_data: { canvas: '', blackboard: '' },
            };
          }
        });
    }
  }

  alreadyExists() {
    var keyExists = false;

    for (var i = 0; i < this.currentKeys.length; i++) {
      var currentKey = this.currentKeys[i];

      if (this.newKey.name + '__c' == currentKey.name) {
        keyExists = true;
        break;
      }
    }

    return keyExists;
  }

  updateKey(key) {
    this.dataModelService.updateKey(this.modelId, key).subscribe(data => {
      this.getKeys();
    });
  }

  removeKey(name) {
    let settings: any = {
      context: {
        data: {
          title: 'Delete ' + name + '?',
          message: 'Are you sure you want to delete ' + name,
        },
      },
    };
    var dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      if (result) {
        this.dataModelService.deleteKey(this.modelId, name).subscribe(data => {
          this.getKeys();
        });
      }
    });
    // Prompt for confirmation
    // this.dataModelService.removeKey(this.modelId, name).subscribe();
  }

  deleteModel() {
    let settings: any = {
      context: {
        data: {
          title: 'Delete Type?',
          message:
            'You are about to delete this data type, this cannot be recovered. Are you sure you want to delete this?',
        },
      },
    };
    var dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      if (result) {
        this.dataModelService.deleteType(this.modelId).subscribe(data => {
          this.dataModelService.updateTypes();
          this.router.navigateByUrl('/data-models');
        });
      }
    });
  }

  private getKeys() {
    this.dataModelService.getKeys(this.modelId).subscribe(modelKeys => {
      for (var i = 0; i < modelKeys.length; i++) {
        this.keyUpdated[i] = false;

        if (modelKeys[i].json_data == null) {
          modelKeys[i].json_data = {};
        }
      }
      this.currentKeys = modelKeys;
      console.log(this.currentKeys);
    });
  }
}
